import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { concat, each, find } from 'lodash';
  
const SessionTransformationStatus = props => {

  if (props.pTransformations) {
    const transformationStatus = props.pTransformations.map(tStatus => {

      return concat(
        <div 
          key={`project_transformation_${tStatus.id}`} 
          className="single-container">
          <span
            className="single-container--name">
            {tStatus.name} : 
          </span>
          <span
            className={`single-container--status_${tStatus.status}`}>
            {statusFormat(tStatus.status)} 
          </span>
        </div>  
      );
    })
 
    return (
      <div
        className="sessionTransformationStatus__container"
      >
       {transformationStatus}
      </div>
    );
  }

  return false;
};

SessionTransformationStatus.propTypes = {
  dataTree: PropTypes.object,
  projectTransformations: PropTypes.array
};

export default connect((state, props) => {

  let pTransformations = [];

  if(props.projectTransformations != null){
    each(props.projectTransformations, (pTransformation, key) => {
      let transformation = find(state.projects.single.fileImport.projectTransformations, {
        id: pTransformation.data_tree_node_transformation.transformation_id 
      });

      let tStatus = pTransformation.data_tree_node_transformation.status;

      if(pTransformation.node_transformation){
        tStatus = pTransformation.node_transformation.status;
      }

      pTransformations.push({
        id: pTransformation.data_tree_node_transformation.transformation_id,
        name: transformation.name,
        status: tStatus
      });
    });
  }
  return {
    pTransformations
  };
})(SessionTransformationStatus);

function statusFormat(status) {
  switch(status) {
    case 'notStarted':
      return 'Not started';

    case 'inProgress':
      return 'In progress'
    
    case 'success':
      return 'Success'

    case 'fail':
      return 'Fail'

    default:
      return '';
  }
}



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/SessionTransformationStatus.js